function debounce(f, ms) {
    var isCooldown = false;

    return function() {
        if (isCooldown) return;
        f.apply(this, arguments);
        isCooldown = true;
        setTimeout(function() {
            isCooldown = false
        }, ms);
    };
}

module.exports = {debounce: debounce}



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/helpers.js
 ** module id = 68
 ** module chunks = 5
 **/